import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

class LatestNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      renderedData: []
    };
  }

  renderLink = (to, title) => (<Link key={title} to={to} onClick={() => this.props.handleMenu()}>{title}</Link>);

  renderData = () => {
    const renderedData = this.state.data.map(item => this.renderLink(item.to, item.title));
    this.setState({
      renderedData
    });
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.latestNews !== this.props.latestNews &&
      Array.isArray(this.props.latestNews) &&
      !!this.props.latestNews.length) {
      let { latestNews } = this.props;
      if (latestNews.length > 10) {
        latestNews = latestNews.slice(0, 10);
      }
      this.setState({
        data: latestNews.map((article) => {
          const { attributes, id } = article;
          return {
            title: attributes.title,
            to: `/article/${id}`
          };
        })
      }, () => {
        this.renderData();
      });
    }
  }

  componentDidMount = () => {
    if (Array.isArray(this.props.latestNews) &&
      !!this.props.latestNews.length) {
      let { latestNews } = this.props;
      if (latestNews.length > 10) {
        latestNews = latestNews.slice(0, 10);
      }
      this.setState({
        data: latestNews.map((article) => {
          const { attributes, id } = article;
          return {
            title: attributes.title,
            to: `/article/${id}`
          };
        })
      }, () => {
        this.renderData();
      });
    }
  }

  render() {
    const { renderedData } = this.state;
    return (
      renderedData.length > 0 && (
        <div className="nav-menu-links-list nav-menu-latest-news">
          <h4>LATEST UPDATES</h4>
          <div className="header-underline" />
          {renderedData.map(item => (
            item
          ))}
        </div>
      )
    );
  }
}

const mapStateToProps = state => ({
  latestNews: state.latestNews.latestNews
});

export default connect(mapStateToProps)(LatestNews);
